import { Radar, mixins } from "vue-chartjs";
export default {
  extends: Radar,
  mixins: [mixins.reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      handler(newVal) {
        this.renderChart(newVal, this.options);
      },
      deep: true
    }
  }
};
